import { Extension } from '@tiptap/core';
import { ReactRenderer } from '@tiptap/react';
import Suggestion from '@tiptap/suggestion';
import tippy from 'tippy.js';
import SlashCommandList from '../SlashCommandList';
import { SLASH_ITEMS, filterSlashItems } from '../slashItems';

/* Docs v1 — the "/" block menu (TipTap wiring only).
   The catalogue + filtering live in ../slashItems.js as pure functions; this
   file is just the Suggestion plugin + popup, mirroring the existing student
   @mention menu (components/Notes/Editor/suggestion.js) so there is one popup
   pattern in the codebase rather than two. */

const SlashCommand = Extension.create({
	name: 'slashCommand',

	addOptions() {
		return {
			capabilities: {},
			suggestion: {
				char: '/',
				// Only trigger at the start of a block, so typing a URL path or
				// "and/or" mid-sentence never pops the menu.
				startOfLine: true,
				command: ({ editor, range, props }) => props.command({ editor, range }),
			},
		};
	},

	addProseMirrorPlugins() {
		const capabilities = this.options.capabilities;
		const editor = this.editor;

		return [
			Suggestion({
				editor: this.editor,
				...this.options.suggestion,

				/* Context is read at menu-open time, not at registration time, so
				   the row/column actions appear exactly when the cursor is inside a
				   table and never when they would silently no-op. */
				items: ({ query }) =>
					filterSlashItems(SLASH_ITEMS, query, capabilities, {
						inTable: editor.isActive('table'),
					}),

				render: () => {
					let component;
					let popup;

					return {
						onStart: (props) => {
							component = new ReactRenderer(SlashCommandList, {
								props,
								editor: props.editor,
							});

							if (!props.clientRect) return;

							popup = tippy('body', {
								getReferenceClientRect: props.clientRect,
								appendTo: () => document.body,
								content: component.element,
								showOnCreate: true,
								interactive: true,
								trigger: 'manual',
								placement: 'bottom-start',
							});
						},

						onUpdate(props) {
							component.updateProps(props);
							if (!props.clientRect) return;
							popup[0].setProps({ getReferenceClientRect: props.clientRect });
						},

						onKeyDown(props) {
							if (props.event.key === 'Escape') {
								popup[0].hide();
								return true;
							}
							return component.ref?.onKeyDown(props);
						},

						onExit() {
							popup[0]?.destroy();
							component?.destroy();
						},
					};
				},
			}),
		];
	},
});

export default SlashCommand;
